import React, { useState } from 'react';
import { Alert, IconButton } from '@mui/material';
import useStyles from '../style/js-style/components/EAAlertStyle';
import EAAlertIcon from './common/EAAlertIcon';
import EAAlertCloseIcon from './common/EAAlertCloseIcon';

const EAAlert = ({
  severity,
  onClose = () => {},
  closable = true,
  children,
}) => {
  const [alertOpen, setAlertOpen] = useState(true);
  const { classes } = useStyles();

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return alertOpen ? (
    <Alert
      severity={severity}
      icon={<EAAlertIcon severity={severity} />}
      onClose={() => closable && handleAlertClose()}
      action={
        closable && (
          <IconButton
            style={{ marginLeft: '28px' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              handleAlertClose();
              onClose();
            }}
          >
            <EAAlertCloseIcon severity={severity} />
          </IconButton>
        )
      }
      className={classes.alert}
    >
      {children}
    </Alert>
  ) : (
    <></>
  );
};

export default EAAlert;
